import PropTypes from 'prop-types'
import { useContext, useEffect, useMemo, useState } from 'react'

import { RootStoreContext } from '@/stores/RootStore'
import { randomizeArray } from '@/utils/helpers'

import QuizQuestion from './QuizQuestion'
function Quiz({ quizData, onSubmit }) {
  const quizQuestions = useMemo(() => {
    const randomizedQuestions = randomizeArray(quizData.questions)
    const questionsToShow = quizData.numQuestionsToDisplay || quizData.questions.length
    return randomizedQuestions.slice(0, questionsToShow)
  }, [quizData])
  const [answers, setAnswers] = useState({})
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const currentQuestion = quizQuestions[currentQuestionIndex]
  const { course: courseContext } = useContext(RootStoreContext)

  useEffect(() => {
    courseContext.setQuizQuestion(currentQuestion?.id)
    return () => courseContext.setQuizQuestion(null)
  }, [currentQuestion, courseContext])

  const prepResponses = (obj) => {
    const responses = []
    Object.keys(obj).forEach((key) => {
      if (Array.isArray(obj[key])) {
        if (obj[key][0]?.value) {
          // map [{value: 'x'}...] to ['x'...]
          responses.push({ question_id: key, answers: obj[key].map((o) => o.value) })
        } else {
          responses.push({ question_id: key, answers: obj[key] })
        }
      } else {
        responses.push({ question_id: key, answers: [obj[key]] })
      }
    })
    return responses
  }

  const setAnswer = (answer) => {
    // add to answers object
    const newState = { ...answers, [currentQuestion.id]: answer }
    setAnswers(newState)
    // go to next question
    if (currentQuestionIndex < quizQuestions.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1)
    } else {
      // submit answers
      const responses = prepResponses(newState)
      onSubmit(responses)
    }
  }
  return (
    <div className="flex h-full flex-col gap-8">
      <div className="bg-muted flex w-full items-center justify-between p-2.5">
        <h2>
          Question <span className="text-4xl">{currentQuestionIndex + 1}</span> of{' '}
          <span className="text-4xl">{quizQuestions.length}</span>
        </h2>
      </div>
      <div className="flex flex-col gap-4 p-4">
        <div className="mx-2 text-2xl font-bold md:text-3xl">{currentQuestion.text}</div>
        <QuizQuestion
          question={currentQuestion}
          setAnswer={setAnswer}
          key={currentQuestion.id}
          isLastQuestion={currentQuestionIndex + 1 === quizQuestions.length}
        />
      </div>
    </div>
  )
}

export default Quiz

Quiz.propTypes = {
  quizData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
